'use client'
import { useState, useEffect, useRef, useContext, } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import './tc.css'
import Application from '../../StateContext/Application';
import { apiurl } from '../../../../path';


const ViewChatForAdmin = () => {
  const { Ticketid, Sender } = useParams();
  const message = useRef(null)
  const statecalls = useContext(Application);
  const { GetTicketInfos, ShowMessages, SendTicketChatDMA, CloseTickets, TicketForwardToHO, Usermenu } = statecalls;
  const [messagelog, Setmessagelog] = useState([{ 'server': 'down' }])
  const [messagetext, setmessagetext] = useState('')
  const [getdata, setData] = useState([])
  const [status, setStatus] = useState('Open');
  const [adminDatatils, setAdminDatatils] = useState([]);
  let id = Ticketid
  let sender = Sender
  console.log(id, sender)
  if (!id) {
    alert("Check your ID")
    window.location.href = '/Admin/Complaints/'
  }

  const FetchAdminDetails = async () => {
    try {
      const data = await Usermenu();
      setAdminDatatils(data.Data);
      console.log("Admin Details Fetchedsadata:", data.Data);
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    FetchAdminDetails();
    getTicketInfo(id)
  }, [])

  useEffect(() => {
    ShowMessagess(id)
  }, [messagelog])

  // setTimeout(() => {
  //   ShowMessagess(id)
  // }, 10000)
  async function ShowMessagess(id) {
    console.log(id);
    let data = await ShowMessages(id)
    // console.log(data);
    Setmessagelog(data)
  }

  useEffect(() => {
    const chatbox = document.getElementById('chatbox');
    if (chatbox) {
      chatbox.scrollTop = chatbox.scrollHeight;
    }
  }, [message.current])

  async function getTicketInfo(id) {
    let data = await GetTicketInfos(id)
    // console.log(data)
    setData(data)
  }

  const send = () => {
    const messagedd = document.getElementById('w-input-text');
    if (!messagedd) {
      return;
    }

    const message = messagedd.innerHTML;

    if (!message) {
      return;
    }
    SendTicketChatDMA(id, message)
    Setmessagelog([...messagelog, { ChatMessage: message, Sender: 'DMA' }]);
    messagedd.innerHTML = '';
  }
  const displaymessages = (items) => {
    const timestamp = items.date;
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleString();
    console.log(items.Userid);
    return (
      <div key={items._id} className='AI'>
        <p className={items.Userid == sender ? 'reply' : 'sentmess'}>{items.ChatMessage}<span className='username'>{items.Sender}<br />{formattedDate}</span></p>
      </div>
    )
  }

  const handleButtonClick = async () => {
    if (status === 'Open') {
      setStatus('Close');
      let data = await CloseTickets(id, 'Close');
      // console.log(data);
      alert(data.message);
      window.location.href = '/AdminDashboard/ViewTicketForAdmin'
    }
    // else if (status === 'Close') {
    //   setStatus('Open');
    //    let data =  await CloseTickets(id[0], 'Reopen');
    //    console.log(data);
    // }
  };
  const SendToHO = async () => {
    if (status === 'Open') {
      let data = await TicketForwardToHO(id);
      // console.log(data);
      alert(data.message);
      window.location.href = '/AdminDashboard/ViewTicketForAdmin'
    }
  };

  // const isOneDayPassed = (ticketDate) => {
  //   if (!ticketDate) return false;
  //   console.log(ticketDate);
    
  //   const createdDate = new Date(ticketDate);
  //   const currentDate = new Date();

  //   const diffInMs = currentDate - createdDate;
  //   const diffInHours = diffInMs / (1000 * 60 * 60);

  //   return diffInHours >= 24; // true after 24 hours
  // };
  const isOneDayPassed = (ticketDate) => {
  const created = new Date(ticketDate);
  const nextDay = new Date(created);
  nextDay.setDate(created.getDate() + 1);

  return new Date() >= nextDay;
};

  return (
    <div>
      <div className='flex justify-around h-auto w-[95vw] bg-slate-50'>

        <div>
          {
            Array.isArray(getdata) && getdata.map((e) => {
              return (
                <>
                  <h1 className='text-2xl'>Ticket Information</h1>
                  {/* <h6>User ID: <b>{e.Userid}</b></h6> */}
                  <h6>User's Name: <b>{e.fullname}</b></h6>
                  <h6>Contact Number: <b>{e.contact}</b></h6>
                  <h6>Ticket Number:<b> {e.TicketNumber}</b></h6>
                  <h6>Email: <b>{e.email}</b></h6>
                  <h6>District: <b>{e.District}</b></h6>
                  <h6>Taluka: <b>{e.Taluka || "N/A"}</b></h6>
                  <h6>Document File: <b>{<Link to={apiurl + '/Complaints/' + e.document} target='_blank'>{e.document}</Link>}</b></h6>
                  <h6>Photo: <b>{<Link to={apiurl + '/Complaints/' + e.photo} target='_blank'>{e.photo}</Link>}</b></h6>
                  <h6>Ticket Status: <b>{e.TicketStatus}</b>
                    <button
                      type="button"
                      onClick={handleButtonClick}
                      className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2 mx-3 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      disabled={status === 'Close'}>
                      {/* {status === 'Open' || status==="Reopen" || status==="Reopen By User" ? 'Close Ticket' : 'Reopen Ticket'} */}
                      Close Ticket
                    </button>
                    { adminDatatils.Role === 'Grievance' && isOneDayPassed(e.Date) &&
                      <button
                        type="button"
                        onClick={SendToHO}
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2 mx-3 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        disabled={status === 'Close'}>
                        {/* {status === 'Open' || status==="Reopen" || status==="Reopen By User" ? 'Close Ticket' : 'Reopen Ticket'} */}
                        Send Ticket To HO
                      </button>
                    }
                  </h6>
                </>
              )
            })
          }
        </div>
      </div>

      <h1 className='text-2xl text-center text-black bg-slate-300'>Ticket Chat</h1>
      <div className='chatbox' id='chatbox'>
        <hr></hr>
        <div id='AI'>
          {Array.isArray(messagelog) && messagelog.map((items) => {
            return displaymessages(items)
          })}
        </div>
      </div>


      <div style={{ display: 'inline-flex' }} className='input-container1'>
        <div id="w-input-container" >
          <div className="w-input-text-group">
            <div id="w-input-text" contentEditable onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                const text = e.currentTarget.innerText.trim();
              }
            }} onChange={(e) => setmessagetext(e.currentTarget.innerHTML)} ></div>

          </div>
        </div>
        <button className="buttonsub" onClick={send} type="button"></button>
      </div>

    </div>
  )
}

export default ViewChatForAdmin
